export default {
  responsive: true,
  maintainAspectRatio: false,
  legend: { display: false },
  tooltips: { cornerRadius: 0 },
  scales: {
    xAxes: [{
      display: true,
      gridLines: {
        display: true,
        color: 'rgba(0, 0, 0, 0.08)'
      },
      ticks: {
        beginAtZero: true
      }
    }],
    yAxes: [{
      display: true
    }]
  }
}



// WEBPACK FOOTER //
// ./src/utils/chart-options/horizontalLinesBar.js